$(document).ready(function () {
  var alreadyLoaded = 0;
  setTimeout(function () {
    alreadyLoaded = 1;
  }, 1500);

  $(document).on("click", ".drawer_show-case-url-link", function (evt) {
    evt.preventDefault();
    var newUrl = $(this).attr("href");
    window.location.href = newUrl;
  });

  $(".collection-filter_tab").on("click", function () {
    if ($(this).hasClass("main-filter_label")) {
      if (alreadyLoaded == 1) {
        $(".collection_filter-dropdown").slideToggle();
        $(this).toggleClass("activeTab");
      }
    } else if ($(this).hasClass("main-filter_selectable")) {
      $(".collection-filter_tab.main-filter_selectable").show();
      $(this).hide();
      $(this)
        .closest(".collection-filter_whole_box")
        .find(".collection-filter_tab")
        .removeClass("active");
      var filter = $(this).attr("data-collection");
      filterCollection(filter, true);
      var currentValue = $(this).find("p").html();
      var currentImage = $(this)
        .find("img.collection-filter_tab_active")
        .attr("src");
      $(".collection-filter_tab.main-filter_label")
        .find("p")
        .html(currentValue);
      $(".collection-filter_tab.main-filter_label")
        .find("img.collection-filter_tab_noactive")
        .attr("src", currentImage);

      $(".collection_filter-dropdown").slideUp();
      $(".collection-filter_tab.main-filter_label").removeClass("activeTab");
    } else {
      $(this)
        .closest(".collection-filter_whole_box")
        .find(".collection-filter_tab")
        .removeClass("active");
      $(this).addClass("active");
      var filter = $(this).attr("data-collection");
      filterCollection(filter, true);
    }
  });

  function filterCollection(filter, updateUrl) {
    console.log(filter, "FILTERING");

    $(".collecton_products-card").each(function () {
      var collectionsList = $(this).attr("data-collections");
      if (collectionsList && collectionsList.includes(filter)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    if (updateUrl) {
      const url = new URL(window.location);
      if (filter) url.searchParams.set("filter", filter);
      else url.searchParams.delete("filter");
      history.pushState({}, "", url);
    }

    $(".collection-filter_whole_dropdown").addClass("loaded");
  }

  function applyFilterFromUrl() {
    const url = new URL(window.location);
    const filter = url.searchParams.get("filter");

    if (filter) {
      var $tabs = $('.collection-filter_tab[data-collection="' + filter + '"]');

      if ($tabs.length) {
        $tabs.each(function () {
          $(this).trigger("click");
          console.log("clicked:", this);
        });
      } else {
        filterCollection(filter, false);
      }
    } else {
      var $active = $(".collection-filter_tab.active");
      if ($active.length) $active.trigger("click");
      else $(".collection-filter_tab").first().trigger("click");
    }
  }

  $(function () {
    if (!window.__cmDisableUrlFilter) applyFilterFromUrl();
  });

  window.addEventListener("popstate", function () {
    if (!window.__cmDisableUrlFilter) applyFilterFromUrl();
    applySortFromUrl();
  });

  function sortByHighestDiscount() {
    var $grid = $(".collection_products-grid");
    var cards = $grid.find(".collecton_products-card").get();
    cards.sort(function (a, b) {
      return (parseFloat($(b).attr("data-discount")) || 0) - (parseFloat($(a).attr("data-discount")) || 0);
    });
    $grid.append(cards);
  }

  function applySortFromUrl() {
    var params = new URL(window.location).searchParams;
    var sortBy = params.get("sort_by") || "";

    if (sortBy === "highest-discount") {
      sortByHighestDiscount();
      var $opt = $('.collection_sorts-value[data="highest-discount"]');
      if ($opt.length) {
        $(".collection_sorting-label").html($opt.html());
        $(".collection_sorts-value").removeClass("active");
        $opt.addClass("active");
      }
      return;
    }

    var reverseMap = {
      "price-ascending": "price-asc",
      "price-descending": "price-desc",
      "created-descending": "newest",
      "best-selling": "best-selling",
      "": "best-selling",
    };

    var key = reverseMap.hasOwnProperty(sortBy) ? reverseMap[sortBy] : "default";
    var $opt = $('.collection_sorts-value[data="' + key + '"]');

    if ($opt.length) {
      $(".collection_sorting-label").html($opt.html());
      $(".collection_sorts-value").removeClass("active");
      $opt.addClass("active");
    } else {
      var $first = $(".collection_sorts-value").first();
      if ($first.length) {
        $(".collection_sorting-label").html($first.html());
        $(".collection_sorts-value").removeClass("active");
        $first.addClass("active");
      }
    }
  }

  $(".collection_sorts-value").click(function () {
    var thisHtml = $(this).html();
    $(".collection_sorting-label").html(thisHtml);

    var value = $(this).attr("data");

    if (value === "highest-discount") {
      sortByHighestDiscount();
      $(".collection_sorts-value").removeClass("active");
      $(this).addClass("active");
      var url = new URL(window.location);
      url.searchParams.set("sort_by", "highest-discount");
      history.pushState({}, "", url);
      return;
    }

    var map = {
      "price-asc": "price-ascending",
      "price-desc": "price-descending",
      newest: "created-descending",
      "best-selling": "best-selling",
      default: "best-selling",
    };

    var url = new URL(window.location);
    var sortVal = map[value] || "";

    if (sortVal) url.searchParams.set("sort_by", sortVal);
    else url.searchParams.delete("sort_by");

    window.location = url.toString();
  });

  $(function () {
    applySortFromUrl();
  });

  $(".collection_sorting").click(function () {
    $(this).find(".collection_sorts-box").slideToggle();
  });

  $(document).click(function (e) {
    if (!$(e.target).closest(".collection_sorting").length) {
      $(".collection_sorts-box").slideUp();
    }
  });

  $(".collecton_products-card").mouseover(function () {
    loadCardHoverImage($(this));
    $(this).addClass("hovered");
  });
  $(".collecton_products-card").mouseleave(function () {
    $(this).removeClass("hovered");
  });
});

// Mouse devices get a card's hover image once the card is near the screen, so the first hover is instant
$(document).ready(function () {
  if (!window.matchMedia("(hover: hover)").matches || !("IntersectionObserver" in window)) return;
  var hoverImageObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        loadCardHoverImage($(entry.target));
        hoverImageObserver.unobserve(entry.target);
      });
    },
    { rootMargin: "200px 0px" },
  );
  $(".collecton_products-card").each(function () {
    hoverImageObserver.observe(this);
  });
});

// The hover image ships as a placeholder with the real file in data-src, so phones don't download it up front
function loadCardHoverImage($card) {
  var $img = $card.find(".collection_product-image-secondary[data-src]");
  if (!$img.length) return;
  $img.attr("src", $img.attr("data-src")).removeAttr("data-src");
}
